module.exports = __webpack_public_path__ + "static/media/github.cf964694.jpg";